import _ from 'lodash';
import roles from 'app/validators/roles';
import { getUserTemplates } from 'app/actions/dictionaries.actions';
import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import { checkAccess } from 'app/actions/app.actions';
import accountStatusTemplate from './account-status.html';

const OTHER_STATUS_KEY = 'OTHER';
const DIRTY_FORM = 'accountStatus';

const mapStateToThis = ({ dictionaries, session }) => ({
  userTemplates: dictionaries.userTemplates,
  locale: session.locale,
});

const mapDispatchToThis = {
  setDirtyForm,
  getUserTemplates,
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', 'gettextCatalog', 'Notifications', 'Responsive')
class AccountStatusController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    this.DIRTY_FORM = DIRTY_FORM;
    this.sessionUserClass = _.get(this.model, 'session.role');
    this.sessionEmailAddress = _.get(this.model, 'session.emailAddress');
    this.userClass = _.get(this.model, 'user.editAccount.userClass');
    this.editingEmailAddress = _.get(this.model, 'user.editAccount.username'); 
    this.isEditingSelf = this.sessionEmailAddress === this.editingEmailAddress;
    this.isUserSameClassAsEditingUser = this.sessionUserClass === this.userClass;
    this.canChangeUserPrivileges = this.checkAccess('user.updateUserPermissions') && !(this.isUserSameClassAsEditingUser && this.sessionUserClass === 'RETAILER_PRIMARY') && !this.isEditingSelf;
    this.otherReason = false;
    this.accountStatus = '';
    this.setOnDeselect({ handler: this.cancel.bind(this) });
    this.privilegesChanged = false;
    this.currentUserPresentId = _.get(this.model, 'user.editAccount.currentUserPreset.id');
    this.privilegesCustomized = _.get(this.model, 'user.editAccount.privilegesCustomized');
    this.viewType = roles.ADMIN_ROLES.indexOf(this.userClass) === -1 ? 'retailerView' : 'lotteryView';
    this.canChangeRole = this.checkAccess('user.changeRole') && !(this.isUserSameClassAsEditingUser && this.sessionUserClass === 'RETAILER_PRIMARY') && !this.isEditingSelf;
    const retailerType = _.get(this.model, 'user.editAccount.primaryRetailer.retailerType');

    await Promise.all([this.getUserTemplates(this.userClass), this.api.loadPrivileges.run(this.userClass, retailerType)]);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  isSecondary() {
    return roles.SECONDARY_USER_ROLES.indexOf(this.userClass) !== -1;
  }

  isAdmin() {
    return roles.ADMIN_ROLES.indexOf(this.userClass) !== -1;
  }

  isPrimary() {
    return roles.PRIMARY_USER_ROLES.indexOf(this.userClass) !== -1;
  }

  save() {
    this.form.$setSubmitted();
    if ((this.isSecondary() || this.isAdmin() || this.isPrimary()) && this.privilegesChanged) {
      this.saveUserPrivileges();
      this.privilegesChanged = false;
    }

    if (this.form.$valid) {
      this.setStatusChangeCallback();
      if (this.saveCallback) {
        this.saveCallback();
      }
      this.clear();
      this.resetForm();
      this.setDirtyForm(this.DIRTY_FORM, false);
    }
  }

  resetPrivileges() {
    this.templateChange(this.model.user.editAccount.currentUserPreset.id);
    this.api.resetCurrentPreset
      .run(this.model.user.editAccount.userClass, this.viewType)
      .then(() => this.Notifications.alertSuccess(this.gettextCatalog.getString('User privileges have been successfully reset.')));
    this.privilegesCustomized = false;
  }

  resetForm() {
    this.$state.go('user-viewAccountDetails', { tabId: 0, skipDirtyForms: true }, { reload: true });
  }

  saveUserPrivileges() {
    this.updateUserPrivileges({ user: this.model.user.editAccount });
  }

  cancel() {
    this.setDirtyForm(this.DIRTY_FORM, false);
    this.clear();
    this.$state.go('user-manageUsers');
  }

  clear() {
    this.updateForm();
    this.form.$setPristine();
    this.form.$setUntouched();
    this.otherReason = false;
    this.onCancelHandler();
  }

  updateForm() {
    this.setStatusChangeCallback();
  }

  setStatusChangeCallback() {
    if (this.accountStatus === 'ACTIVE') {
      this.saveCallback = this.activateCallback;
    } else if (this.accountStatus === 'INACTIVE') {
      this.saveCallback = this.suspendCallback;
    }
  }

  checkReasonStatus() {
    this.otherReason = OTHER_STATUS_KEY === this.model.user.editAccount.reasonKey;
  }

  editPresetPrivileges(privileges) {
    this.model.user.editAccount.privilegeIds = privileges;
    this.privilegesChanged = true;
    this.privilegesCustomized = true;
  }

  templateChange(templateId) {
    if (templateId) {
      let currentPreset = _.cloneDeep(this.userTemplates.find((preset) => preset.id === templateId));
      if (!currentPreset) {
        currentPreset = _.cloneDeep(this.userTemplates[0]);
      }
      this.model.user.editAccount.privilegeIds = currentPreset.privileges;
      this.model.user.editAccount.currentUserPreset = currentPreset;
      this.privilegesChanged = true;
      this.privilegesCustomized = false;
    }
  }
}

export default class AccountStatusComponent {
  constructor() {
    this.template = accountStatusTemplate;
    this.controller = AccountStatusController;
    this.bindings = {
      model: '<',
      api: '<',
      setOnDeselect: '&',
      activateCallback: '&',
      suspendCallback: '&',
      onCancelHandler: '&',
      canChangeUserStatus: '&',
      updateUserPrivileges: '&',
      canEditAccountDetails: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/components/edit-account/components/account-status/account-status-component.js